import { render, staticRenderFns } from "./ServersList.vue?vue&type=template&id=3a2be049&"
import script from "./ServersList.vue?vue&type=script&lang=js&"
export * from "./ServersList.vue?vue&type=script&lang=js&"
import style0 from "./ServersList.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports